import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeEmailGenerateUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.ui || result.emailGenerateUi || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'email-generation') return null

  var personalizationFields = Array.isArray(ui.personalizationFields)
    ? ui.personalizationFields.map(normalizePersonalizationField).filter(Boolean)
    : []
  var preview = ui.preview && typeof ui.preview === 'object' ? ui.preview : {}
  var tokenEstimate = normalizeTokenEstimate(ui.tokenEstimate)
  var advancedInstructionReport = normalizeAdvancedInstructionReport(ui.advancedInstructionReport)
  var transitions = Array.isArray(ui.transitions)
    ? ui.transitions.map(normalizeTransition).filter(Boolean)
    : []
  var testAction = normalizeCampaignTestAction(ui.testAction)

  return {
    type: 'email-generation',
    title: String(ui.title || 'Génération des emails'),
    countLabel: String(ui.countLabel || 'Emails générés'),
    count: normalizeCount(ui.count),
    subjectLabel: String(ui.subjectLabel || 'Objet proposé'),
    subject: String(ui.subject || ''),
    personalizationLabel: String(ui.personalizationLabel || 'Variables de personnalisation'),
    personalizationFields: personalizationFields,
    generationModeLabel: String(ui.generationModeLabel || 'Mode de génération'),
    generationModeDisplay: String(ui.generationModeDisplay || '').trim(),
    tokenEstimate: tokenEstimate,
    advancedInstructionReport: advancedInstructionReport,
    audienceNotice: String(ui.audienceNotice || '').trim(),
    previewLabel: String(ui.previewLabel || "Aperçu sur le premier contact"),
    preview: {
      to: String(preview.to || ''),
      subject: String(preview.subject || ''),
      body: String(preview.body || '')
    },
    testAction: testAction,
    transitions: transitions
  }
}

function normalizeAdvancedInstructionReport(value) {
  if (!value || typeof value !== 'object') return null
  var status = String(value.status || '').trim()
  if (['applied', 'partially_applied', 'not_applied'].indexOf(status) === -1) return null
  var applied = Array.isArray(value.applied)
    ? value.applied.map(function (item) { return String(item || '').trim() }).filter(Boolean)
    : []
  var limitations = Array.isArray(value.limitations)
    ? value.limitations.map(function (item) { return String(item || '').trim() }).filter(Boolean)
    : []
  if (!applied.length && !limitations.length && status === 'applied') return null

  return {
    status: status,
    title: String(value.title || 'Consigne avancée').trim(),
    statusLabel: String(value.statusLabel || 'Consigne avancée').trim(),
    appliedLabel: String(value.appliedLabel || 'Pris en compte').trim(),
    limitationsLabel: String(value.limitationsLabel || 'Limites').trim(),
    applied: applied,
    limitations: limitations
  }
}

function normalizePersonalizationField(field) {
  if (!field || typeof field !== 'object') return null
  var key = String(field.key || '').trim()
  var label = String(field.label || '').trim()
  if (!key || !label) return null

  return {
    key: key,
    label: label,
    valueExample: String(field.valueExample || '').trim()
  }
}

function normalizeTransition(transition) {
  if (!transition || typeof transition !== 'object') return null
  var label = String(transition.label || '').trim()
  var target = String(transition.target || '').trim()
  if (!label || !target) return null
  return { label: label, target: target }
}

function normalizeCampaignTestAction(action) {
  if (!action || typeof action !== 'object') return null
  var label = String(action.label || '').trim()
  var batchId = String(action.batchId || '').trim()
  if (!label || !batchId) return null
  return {
    action: String(action.action || 'campaign_test').trim() || 'campaign_test',
    label: label,
    batchId: batchId,
    enabled: action.enabled !== false
  }
}

function normalizeTokenEstimate(value) {
  if (!value || typeof value !== 'object') return null
  var estimatedTotalTokens = normalizeCount(value.estimatedTotalTokens)
  var label = String(value.label || 'Estimation tokens').trim()
  var message = String(value.message || '').trim()
  var level = String(value.level || 'info').toLowerCase() === 'warning' ? 'warning' : 'info'
  if (!estimatedTotalTokens && !message) return null

  return {
    estimatedTotalTokens: estimatedTotalTokens,
    label: label,
    message: message,
    level: level
  }
}

function normalizeCount(value) {
  var numeric = Number(value)
  return Number.isFinite(numeric) && numeric >= 0 ? numeric : 0
}

function renderEmailGenerateUi(emailGenerateUi, translations) {
  var labels = normalizeEmailGenerateTranslations(translations)
  var chips = emailGenerateUi.personalizationFields.length
    ? emailGenerateUi.personalizationFields.map(function (field) {
      return '<span class="wc-email-generate-chip" title="' + escapeAttributeValue(field.valueExample || '') + '">' +
        escapeHtml(field.label) +
      '</span>'
    }).join('')
    : '<span class="wc-email-generate-empty">' + escapeHtml(labels.noVariables) + '</span>'

  return (
    '<div class="wc-email-generate-ui">' +
      '<div class="wc-ds-capability wc-ds-capability-plume">' +
        '<div class="wc-ds-capability-name">' + renderLucideIcon('feather') + '<span>@Plume</span></div>' +
        '<div class="wc-ds-capability-meta">' + escapeHtml(emailGenerateUi.title || labels.countLabel) + '</div>' +
      '</div>' +
      '<div class="wc-email-generate-card wc-email-generate-count-card">' +
        '<div class="wc-email-generate-card-label">' + escapeHtml(emailGenerateUi.countLabel || labels.countLabel) + '</div>' +
        '<div class="wc-email-generate-count">' + escapeHtml(String(emailGenerateUi.count)) + '</div>' +
      '</div>' +
      renderTokenEstimate(emailGenerateUi) +
      renderAdvancedInstructionReport(emailGenerateUi.advancedInstructionReport) +
      '<section class="wc-email-generate-section">' +
        '<div class="wc-email-generate-section-label">' + escapeHtml(emailGenerateUi.subjectLabel || labels.subjectLabel) + '</div>' +
        '<div class="wc-email-generate-subject">' + escapeHtml(emailGenerateUi.subject || labels.emptySubject) + '</div>' +
      '</section>' +
      '<section class="wc-email-generate-section">' +
        '<div class="wc-email-generate-section-label">' + escapeHtml(emailGenerateUi.personalizationLabel || labels.personalizationLabel) + '</div>' +
        '<div class="wc-email-generate-chips">' + chips + '</div>' +
      '</section>' +
      renderPreview(emailGenerateUi.preview, emailGenerateUi.previewLabel || labels.previewLabel, labels) +
      renderCampaignTestAction(emailGenerateUi.testAction) +
      renderTransitions(emailGenerateUi.transitions) +
    '</div>'
  )
}

function renderAdvancedInstructionReport(report) {
  if (!report) return ''
  var levelClass = report.status === 'applied' ? '' : ' warning'
  var applied = report.applied.length
    ? '<div class="wc-email-generate-instruction-group"><strong>' + escapeHtml(report.appliedLabel) + '</strong><ul>' + report.applied.map(function (item) { return '<li>' + escapeHtml(item) + '</li>' }).join('') + '</ul></div>'
    : ''
  var limitations = report.limitations.length
    ? '<div class="wc-email-generate-instruction-group"><strong>' + escapeHtml(report.limitationsLabel) + '</strong><ul>' + report.limitations.map(function (item) { return '<li>' + escapeHtml(item) + '</li>' }).join('') + '</ul></div>'
    : ''

  return (
    '<section class="wc-email-generate-instruction' + levelClass + '">' +
      renderLucideIcon(report.status === 'applied' ? 'badgeInfo' : 'triangleAlert') +
      '<div class="wc-email-generate-instruction-copy">' +
        '<div class="wc-email-generate-instruction-head">' +
          '<span>' + escapeHtml(report.title) + '</span>' +
          '<strong>' + escapeHtml(report.statusLabel) + '</strong>' +
        '</div>' +
        applied +
        limitations +
      '</div>' +
    '</section>'
  )
}

function renderTokenEstimate(emailGenerateUi) {
  var tokenEstimate = emailGenerateUi.tokenEstimate
  if (!tokenEstimate && !emailGenerateUi.audienceNotice && !emailGenerateUi.generationModeDisplay) return ''

  var levelClass = tokenEstimate && tokenEstimate.level === 'warning' ? ' warning' : ''
  var mode = emailGenerateUi.generationModeDisplay
    ? '<div class="wc-email-generate-token-mode"><span>' + escapeHtml(emailGenerateUi.generationModeLabel || 'Mode de génération') + '</span><strong>' + escapeHtml(emailGenerateUi.generationModeDisplay) + '</strong></div>'
    : ''
  var estimate = tokenEstimate
    ? '<div class="wc-email-generate-token-message"><strong>' + escapeHtml(tokenEstimate.label || 'Estimation tokens') + '</strong><span>' + escapeHtml(tokenEstimate.message || '') + '</span></div>'
    : ''
  var notice = emailGenerateUi.audienceNotice
    ? '<div class="wc-email-generate-token-notice">' + escapeHtml(emailGenerateUi.audienceNotice) + '</div>'
    : ''

  return (
    '<section class="wc-email-generate-token' + levelClass + '">' +
      renderLucideIcon('triangleAlert') +
      '<div class="wc-email-generate-token-copy">' +
        mode +
        estimate +
        notice +
      '</div>' +
    '</section>'
  )
}

function renderPreview(preview, title, labels) {
  return (
    '<section class="wc-email-generate-preview">' +
      '<div class="wc-email-generate-section-label">' + escapeHtml(title || labels.previewLabel) + '</div>' +
      '<div class="wc-email-generate-preview-row">' +
        '<span class="wc-email-generate-preview-key">' + escapeHtml(labels.previewToLabel) + '</span>' +
        '<span class="wc-email-generate-preview-value">' + escapeHtml(preview.to || '') + '</span>' +
      '</div>' +
      '<div class="wc-email-generate-preview-row">' +
        '<span class="wc-email-generate-preview-key">' + escapeHtml(labels.previewSubjectLabel) + '</span>' +
        '<span class="wc-email-generate-preview-value">' + escapeHtml(preview.subject || labels.emptySubject || '') + '</span>' +
      '</div>' +
      '<div class="wc-email-generate-section-label">' + escapeHtml(labels.previewBodyLabel) + '</div>' +
      '<div class="wc-email-generate-preview-body">' + renderMultiline(preview.body || '') + '</div>' +
    '</section>'
  )
}

function renderTransitions(transitions) {
  if (!Array.isArray(transitions) || !transitions.length) return ''

  return (
    '<div class="wc-email-generate-transitions">' +
      transitions.map(function (transition) {
        return '<button type="button" class="wc-email-generate-transition" data-step-key="' + escapeAttributeValue(transition.target || '') + '">' + renderLucideIcon('chevronRight') + '<span>' + escapeHtml(transition.label) + '</span></button>'
      }).join('') +
    '</div>'
  )
}

function renderCampaignTestAction(action) {
  if (!action) return ''
  return (
    '<div class="wc-email-generate-transitions">' +
      '<button type="button" class="wc-email-generate-transition wc-email-generate-test-action" data-email-campaign-test-action="true" data-batch-id="' + escapeAttributeValue(action.batchId || '') + '"' + (action.enabled ? '' : ' disabled') + '>' +
        renderLucideIcon('mailCheck') +
        '<span>' + escapeHtml(action.label || 'Envoyer un test') + '</span>' +
      '</button>' +
    '</div>'
  )
}

function bindEmailGenerateUi(el, emailGenerateUi, handlers) {
  if (!el || !emailGenerateUi) return
  var testButton = el.querySelector('.wc-email-generate-test-action')
  if (testButton && emailGenerateUi.testAction) {
    testButton.addEventListener('click', function () {
      if (handlers && typeof handlers.onCampaignTest === 'function') {
        handlers.onCampaignTest(emailGenerateUi.testAction)
      }
    })
  }
  Array.prototype.slice.call(el.querySelectorAll('.wc-email-generate-transition')).forEach(function (button, index) {
    if (button.getAttribute('data-email-campaign-test-action') === 'true') return
    var stepKey = String(button.getAttribute('data-step-key') || '').trim()
    var transition = findTransitionByTarget(emailGenerateUi.transitions, stepKey)
    if (!transition || !transition.target) return
    button.addEventListener('click', function () {
      if (handlers && typeof handlers.onTransition === 'function') {
        handlers.onTransition(transition)
      }
    })
  })
}

function findTransitionByTarget(transitions, target) {
  if (!target || !Array.isArray(transitions)) return null
  for (var i = 0; i < transitions.length; i += 1) {
    if (transitions[i] && transitions[i].target === target) {
      return transitions[i]
    }
  }
  return null
}

function renderMultiline(value) {
  return escapeHtml(String(value || '')).replace(/\n/g, '<br>')
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeAttributeValue(value) {
  return escapeHtml(value).replace(/`/g, '&#96;')
}

function normalizeEmailGenerateTranslations(translations) {
  var fallback = {
    countLabel: 'Emails générés',
    subjectLabel: 'Objet proposé',
    personalizationLabel: 'Variables de personnalisation',
    previewLabel: 'Aperçu sur le premier contact',
    previewToLabel: 'A',
    previewSubjectLabel: 'Objet',
    previewBodyLabel: "Corps de l'email",
    noVariables: 'Aucune variable détectée',
    emptySubject: 'Objet généré automatiquement'
  }

  var normalized = Object.assign({}, fallback, translations || {})
  var preview = translations && typeof translations.preview === 'object' ? translations.preview : {}

  normalized.previewToLabel = String(preview.to || normalized.previewToLabel)
  normalized.previewSubjectLabel = String(preview.subject || normalized.previewSubjectLabel)
  normalized.previewBodyLabel = String(preview.body || normalized.previewBodyLabel)

  return normalized
}

export { normalizeEmailGenerateUi, renderEmailGenerateUi, bindEmailGenerateUi }
